<template>
  <div :class="`card-info`">
    <div class="shadow-wrapper" @click="close"></div>
    <div class="content">
      <div >
        <card class="card" :title="'Перевести в новый класс'">
          <div>
            <form @submit.prevent>

              <fields-list :fields="fields" :item="item" :class="fieldClass"  />
             
              <div class="clearfix"></div>

              <div class="save-panel">

                 <p-button
                  class=" mr-2"
                  round
                  @click.native.prevent="close($event, true)"
                  ><span class="ti-arrow-left"> </span> Назад</p-button
                >
                <p-button
                  class=""
                  type="info"
                  @click.native.prevent="addItem"
                  >Применить</p-button>
     
              </div>
            </form>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { errorNotify, multiKeyInit, cardUpdate } from "@/plugins/functions";

export default {
  created() {
    let item = {};
    this.fields = [];
    this.fields = this.fieldsFrom.slice();

    for (let i = 0; i < this.fields.length; i++) {
      item[this.fields[i].key] = "";
    }

    this.item = this.multiKeyInit(item, this, 0);
  },
  data() {
    return {
      item: {},
      fields:[]
    };
  },
  props: {
    fieldClass: {
      default: "",
    },
    setLink: {
      default: "",
    },
    cardLink: {
      default: "",
    },
    openItem: {
      default: true,
    },
    modalTitle: {
      default: "",
    },
    modalCreate: {
      default: "",
    },
    fieldsFrom: {
      type: Array,
      default: {
        function(prams) {
          return [];
        },
      },
    },
    onCreateOpen: {
      default: true,
    },
    getList: {
      default: function () {
        return false;
      },
    },
  },
  methods: {
    multiKeyInit: multiKeyInit,
    errorNotify: errorNotify,
    cardUpdate: cardUpdate,
    close() {
      this.item = {};
      this.$emit('close',true);
    },
    modalOpen() {
      
    },
    async addItem() {
      console.log(this.setLink, 'this.setLink')
      let item = await this.cardUpdate(this.setLink, this.item, this.fields, 'POST' );
      if(item && item.result){
        // this.$emit('getList');
        this.close()
        this.getList()
        return 
      }
      this.getList()
      this.close();
      return
      if (item && item.id){
           this.close();
            console.log('this.cardLink', this.cardLink, query[this.cardLink], query)
           if( this.openItem === true ){
            let query = Object.assign({}, this.$route.query);
            if (query[this.cardLink]) {
              delete query[this.cardLink];
            }
            query[this.cardLink] = item.id;
            setTimeout(() => {
              this.$router.replace({ query: query });
            }, 20);
            }
      }
    },
    // dev
    // async addItem() {
    //   let item = await this.cardUpdate(this.setLink, this.item, this.fields, 'POST' );

    //   if (item && item.id){
    //       this.$emit('close',true);

    //        if( this.openItem === true ){
    //         let query = Object.assign({}, this.$route.query);
    //         if (query[this.cardLink]) {
    //           delete query[this.cardLink];
    //         }
    //         query[this.cardLink] = item.id;
    //         setTimeout(() => {
    //           this.$router.replace({ query: query });
    //         }, 20);
    //         }
    //   }
    // },
  },
};
</script>